export default {
    workOrder_customerTab_name: "Nombre",
    workOrder_customerTab_eIn: "EIN",
    workOrder_customerTab_contact: "Contacto",
    workOrder_customerTab_email: "Correo",
    workOrder_customerTab_phone: "Teléfono",
    workOrder_customerTab_address: "Dirección",
    workOrder_customerTab_driver: "Conductor",
    workOrder_customerTab_createContact: "Crear contacto",
    workOrder_customerTab_createLocation: "Crear Ubicación",
    workOrder_customerTab_importFinished: "Importación Finalizada",
    workOrder_customerTab_seeSummary: "Para ver el resumen, haga clic aquí",
    workOrder_customerTab_importCustomers: "Importar clientes",
};